import { queryOptions } from '@tanstack/react-query';

import { fetchDebugInfo } from 'services/backend/debugInfo';

export const debugInfoQueries = {
  get: queryOptions({
    queryFn: () => fetchDebugInfo(),
    queryKey: ['debugInfo'],
    retry: false,
    staleTime: Infinity,
  }),
};
